var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.submit()
        }
      }
    },
    [
      _c("step-text", [
        _vm._v(
          "Para começarmos o seu cadastro precisamos que você nos informe os dados da sua conta:"
        )
      ]),
      _vm._v(" "),
      _vm.isPhysical
        ? [
            _c("base-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:2|alpha_spaces",
                  expression: "'required|min:2|alpha_spaces'"
                }
              ],
              attrs: {
                error: _vm.errors.first("Nome"),
                label: "Nome",
                "custom-classes": "capitalize"
              },
              model: {
                value: _vm.first_name,
                callback: function($$v) {
                  _vm.first_name = $$v
                },
                expression: "first_name"
              }
            }),
            _vm._v(" "),
            _c("base-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:2|alpha_spaces",
                  expression: "'required|min:2|alpha_spaces'"
                }
              ],
              attrs: {
                error: _vm.errors.first("Sobrenome"),
                label: "Sobrenome",
                "custom-classes": "capitalize"
              },
              model: {
                value: _vm.last_name,
                callback: function($$v) {
                  _vm.last_name = $$v
                },
                expression: "last_name"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|email",
            expression: "'required|email'"
          }
        ],
        attrs: {
          error: _vm.errors.first("email"),
          label: "E-mail",
          "data-vv-as": "E-mail",
          name: "email",
          type: "email"
        },
        model: {
          value: _vm.email,
          callback: function($$v) {
            _vm.email = $$v
          },
          expression: "email"
        }
      }),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|min:8",
            expression: "'required|min:8'"
          }
        ],
        ref: "senha",
        attrs: {
          error: _vm.errors.first("Senha"),
          label: "Senha",
          type: "password"
        },
        model: {
          value: _vm.password,
          callback: function($$v) {
            _vm.password = $$v
          },
          expression: "password"
        }
      }),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|min:8|confirmed:senha",
            expression: "'required|min:8|confirmed:senha'"
          }
        ],
        attrs: {
          error: _vm.errors.first("Confirme a senha"),
          label: "Confirme a senha",
          type: "password"
        },
        model: {
          value: _vm.password_confirmation,
          callback: function($$v) {
            _vm.password_confirmation = $$v
          },
          expression: "password_confirmation"
        }
      }),
      _vm._v(" "),
      _c(
        "base-flex",
        { staticClass: "mt-10", attrs: { justify: "end" } },
        [
          _c(
            "base-button",
            {
              attrs: { outlined: "" },
              on: {
                click: function($event) {
                  _vm.prevStep()
                }
              }
            },
            [_vm._v("voltar")]
          ),
          _vm._v(" "),
          _c("base-button", { attrs: { type: "submit" } }, [
            _vm._v("continuar")
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-986a60c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-986a60c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp/Steps/Account.vue
// module id = null
// module chunks = 